module.exports = __webpack_public_path__ + "img/risk-high.e0ab6f62.png";